<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="800px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="编号" prop="no">
            <el-input v-model.trim="model.no" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input v-model.trim="model.name" placeholder="请输入名称"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="外部编号">
            <el-input v-model.trim="model.outerNO" placeholder="请输入外部编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="简称">
            <el-input v-model.trim="model.shortName" placeholder="请输入简称"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="缩写">
            <el-input v-model.trim="model.shortCode" placeholder="请输入缩写"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人">
            <el-input v-model.trim="model.contact" placeholder="请输入联系人"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系方式">
            <el-input v-model.trim="model.mobile" placeholder="请输入联系方式"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行">
            <el-input v-model.trim="model.bank" placeholder="请输入开户行"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开户行号">
            <el-input v-model.trim="model.vATNO" placeholder="请输入开户行号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户名">
            <el-input v-model.trim="model.vATNAME" placeholder="请输入开户名"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="收款账号">
            <el-input v-model.trim="model.accounts" placeholder="请输入收款账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系地址">
            <el-input v-model="model.address" placeholder="请输入联系地址"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model.trim="model.note" type="textarea" autosize placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "SupplierManageEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        model: {
          pkid: "",
          no: "",
          name: "",
          shortCode: "",
          shortName: "",
          outerNO: "",
          contact: "",
          mobile: "",
          postCode: "",
          address: "",
          bank: "",
          vATNO: "",
          vATNAME: "",
          accounts: "",
          note: "",
        },
        ruleValidate: {
          name: { required: true, message: "不能为空", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getData(row.pkid);
        } else {
          this.getNode();
        }
      },
      getData(pkid) {
        this.$http.get("basic", `supplierInfoes/${pkid}`).then((res) => {
          console.log(res);
          if (res.success) {
            this.model = Object.assign(this.model, res.data);
          }
        });
      },
      getNode() {
        this.$http.get("basic", "supplierInfoes/selectNo").then((resp) => {
          console.log(resp);
          if (resp.success) {
            this.model.no = resp.data;
          }
        });
      },

      handleSubmit() {
        if (this.model.pkid > 0) {
          this.handleSubmitPut();
        } else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "supplierInfoes", this.model)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitPost() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "supplierInfoes", this.model)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
